import { render, staticRenderFns } from "./SchemaDataTable.vue?vue&type=template&id=7e192ed2&scoped=true"
import script from "./SchemaDataTable.vue?vue&type=script&lang=js"
export * from "./SchemaDataTable.vue?vue&type=script&lang=js"
import style0 from "./SchemaDataTable.vue?vue&type=style&index=0&id=7e192ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e192ed2",
  null
  
)

export default component.exports